module.exports = __webpack_public_path__ + "img/icon-2.33fbdec5.png";